import { AttributeValue } from "../../../dom-tools/AttributeValue";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementSelectors } from "../../../dom-tools/ElementSelectors";
import { Filter } from "./Filter";

export class TextMatchFilter extends Filter
{
  static readonly type = new AttributeValue( Filter.setting, "text" );
  static readonly matchAttribute = new ElementAttribute( "-match" );
  static readonly useAttributeValue = new ElementAttribute( "-use--attribute--value" );

  match:RegExp;
  useAttribute:boolean;
  attribute:ElementAttribute;

  constructor( filterSettings:Element )
  {
    super( filterSettings);
    
    this.match = new RegExp( TextMatchFilter.matchAttribute.from( filterSettings, filterSettings.textContent.trim() ) );
    this.useAttribute = TextMatchFilter.useAttributeValue.in( filterSettings );

    if ( this.useAttribute )
    {
      let firstAttributeStart = this.selector.indexOf( "[" );
      let attributeEnd = this.selector.indexOf( "]", firstAttributeStart + 1 );

      let attributeSelector = this.selector.substring( firstAttributeStart + 1, attributeEnd );
      this.attribute = new ElementAttribute( attributeSelector, false );
    }

    let checkbox = ElementSelectors.inputCheckBox.query( filterSettings );

    if ( checkbox )
    {
      this.enabled = checkbox.checked;
    }


  }

  _filterElement( e:Element ) :boolean 
  {
    let element = this.getElement( e );

    let value = "";

    if ( element === null )
    {
      return false;
    }

    if ( this.useAttribute )
    {      
      value = this.attribute.from( element );
    }
    else
    {
      value = element.textContent;
    }

    let result = this.match.test( value );

    return result;
  }
}